import { render, staticRenderFns } from "./HistoricoComponent.vue?vue&type=template&id=0995d63c"
import script from "./HistoricoComponent.vue?vue&type=script&lang=js"
export * from "./HistoricoComponent.vue?vue&type=script&lang=js"
import style0 from "./HistoricoComponent.vue?vue&type=style&index=0&id=0995d63c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports